import { createSlice } from "@reduxjs/toolkit";
import { fetchIntangibleAssetBalance } from "./intangibleAssetThunk";

const intangibleAssetBalanceSlice = createSlice({
  name: "intangibleAssetBalance",
  initialState: {
    list: [],
    total_balance: 0,
    loading: false,
    filters: {
      type: "Date Wise",
      accId: null,
      fromDate: null,
      toDate: null,
    },
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIntangibleAssetBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIntangibleAssetBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.list;
        state.total_balance = action.payload.total_balance;
      })
      .addCase(fetchIntangibleAssetBalance.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = intangibleAssetBalanceSlice.actions;
export default intangibleAssetBalanceSlice.reducer;